var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0205 0.5C20.0491 0.5 22.5 2.94021 22.5 5.94238V6.05762C22.5 8.37711 21.0296 10.9665 19.0625 13.3408C17.1125 15.6945 14.7523 17.7444 13.1338 18.9717C12.6707 19.3201 12.0963 19.5 11.5 19.5C10.8999 19.5 10.3229 19.3227 9.86816 18.9736L9.86621 18.9717L9.22656 18.4746C7.66384 17.2279 5.6438 15.4004 3.9375 13.3408C1.97044 10.9665 0.5 8.37711 0.5 6.05762V5.94238C0.5 2.94021 2.95094 0.5 5.97949 0.5C7.73872 0.500124 9.39369 1.33974 10.4219 2.75391V2.75488L11.0957 3.67871L11.5 4.23242L11.9043 3.67871L12.5781 2.75488V2.75391C13.6063 1.33974 15.2613 0.500124 17.0205 0.5Z",
    fill: "#2A3654",
    fillOpacity: 0.4,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilledIcon);
export default __webpack_public_path__ + "static/media/heart-filled-icon.bf4a461676c4dd88a9df157dd833d169.svg";
export { ForwardRef as ReactComponent };